import { render } from "./OtherPayment.vue?vue&type=template&id=4489b4f1&scoped=true"
import script from "./OtherPayment.vue?vue&type=script&lang=js"
export * from "./OtherPayment.vue?vue&type=script&lang=js"

import "./OtherPayment.vue?vue&type=style&index=0&id=4489b4f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4489b4f1"]])

export default __exports__